/**
 * @file routes.ts
 *
 * @fileoverview Include routes for the application.
 */
const resumeInfo = require('././../../../config/resume');
const appInfo = require('././../../../config/app');

const resumesActive = resumeInfo.public.RESUME_FEATURE_ACTIVE;

//TODO : Remove once we have added BACKEND_URL in all projects.
const backendUrl =
  process.env.BACKEND_URL ??
  process.env.GRAPHQL_ENDPOINT?.replace('/graphql', '');

// Configure redirects.
let redirectsInfo = [
  {
    source: '/backend',
    destination: backendUrl,
    permanent: false,
  },
];

// Hide resume pages if feature disabled.
if (!resumesActive) {
  redirectsInfo = [
    ...redirectsInfo,
    ...[
      {
        source: '/resume',
        destination: '/404',
        permanent: true,
      },
      {
        source: '/resume/:children',
        destination: '/404',
        permanent: true,
      },
      {
        source: `/resume-alert/edit/:id`,
        destination: '/404',
        permanent: true,
      },
    ],
  ];
}

// Custom security headers.
const securityHeaders = [{ key: 'X-Frame-Options', value: 'SAMEORIGIN' }];

const sitemapsRoutes = [
  {
    source: '/sitemap.xml',
    destination: `${backendUrl}/sitemap.xml`,
  },
  {
    source: '/:type/sitemap.xml',
    destination: `${backendUrl}/:type/sitemap.xml`,
  },
  {
    source: '/:lang/:type/sitemap.xml',
    destination: `${backendUrl}/:lang/:type/sitemap.xml`,
  },
  {
    source: '/sitemap.xsl',
    destination: `${backendUrl}/sitemap_generator/default/sitemap.xsl`,
  },
  {
    source: '/:type/sitemap.xsl',
    destination: `${backendUrl}/sitemap_generator/default/sitemap.xsl`,
  },
  {
    source: '/:lang/:type/sitemap.xsl',
    destination: `${backendUrl}/sitemap_generator/default/sitemap.xsl`,
  },
  {
    source: '/modules/contrib/simple_sitemap/:rest*',
    destination: `${backendUrl}/modules/contrib/simple_sitemap/:rest*`,
  },
  {
    source: '/core/assets/vendor/:rest*',
    destination: `${backendUrl}/core/assets/vendor/:rest*`,
  },
  {
    source: '/sitemap/:rest*',
    destination: `${backendUrl}/sitemap/:rest*`,
  },
];

module.exports = {
  sitemaps: sitemapsRoutes,
  routes: [
    // Serve robots.txt from API route that merges core and local rules.
    {
      source: '/robots.txt',
      destination: '/api/robots.txt',
    },
    // Some browsers ignore the favicon link tag in the HTML and look for it in
    // the root of the domain, so we need to add this rewrite to avoid 404
    // errors in the console.
    {
      source: '/favicon.ico',
      destination: '/static/favicon.ico',
    },
  ],
  // Redirects that need to be frontend specific.
  frontendSpecificRedirects: [],
  redirects: redirectsInfo,
  translatedRoutes: {
    'en-GB': [
      // Resume routes for UK.
      {
        pathname: '/resumes*',
        newPathname: '/cvs*',
        file: '/resumes',
      },
      {
        pathname: '/resume/edit*',
        newPathname: '/cv/edit*',
        file: '/resume/edit',
      },
      {
        pathname: '/resume/wizard',
        newPathname: '/cv/wizard',
        file: '/resume/wizard',
      },
      {
        pathname: '/resume/wizard/import',
        newPathname: '/cv/wizard/import',
        file: '/resume/wizard/import',
      },
      {
        pathname: '/resume/wizard/job-preferences',
        newPathname: '/cv/wizard/job-preferences',
        file: '/resume/wizard/job-preferences',
      },
      {
        pathname: '/resume',
        newPathname: '/cv',
        file: '/resume',
      },
      {
        pathname: '/resume/*',
        newPathname: '/cv/*',
        file: '/resume',
      },
    ],
    de: [
      // Resume Routes for DE.
      {
        pathname: '/resumes*',
        newPathname: '/bewerbersuche*',
        file: '/resumes',
      },
      {
        pathname: '/resume/edit*',
        newPathname: '/lebenslauf/edit*',
        file: '/resume/edit',
      },
      {
        pathname: '/resume/wizard',
        newPathname: '/lebenslauf/wizard',
        file: '/resume/wizard',
      },
      {
        pathname: '/resume/wizard/import',
        newPathname: '/lebenslauf/wizard/import',
        file: '/resume/wizard/import',
      },
      {
        pathname: '/resume/wizard/job-preferences',
        newPathname: '/lebenslauf/wizard/job-preferences',
        file: '/resume/wizard/job-preferences',
      },
      {
        pathname: '/resume/wizard/personal-info',
        newPathname: '/lebenslauf/wizard/personal-info',
        file: '/resume/wizard/personal-info',
      },
      {
        pathname: '/resume',
        newPathname: '/lebenslauf',
        file: '/resume',
      },
      {
        pathname: '/resume/*',
        newPathname: '/lebenslauf/*',
        file: '/resume',
      },
      // Organiation Routes for DE
      {
        pathname: '/organizations*',
        newPathname: '/arbeitgeber-suchen*',
        file: '/organizations',
      },
      // Contact page.
      {
        pathname: '/contact',
        newPathname: '/kontakt',
        file: '/contact',
      },
    ],
    fr: [
      // Jobs routes for FR.
      {
        pathname: '/jobs*',
        newPathname: '/emploi*',
        file: '/jobs',
      },
    ],
  },
  headers: [
    // Apply securityHeaders to all routes.
    { source: '/:path*', headers: securityHeaders },
  ],
  // Option to add custom domain to Content-Security-Policy header.
  // This option can be used for example to allow job widget to be embedded
  // on a specific domain.
  cspAllowedDomains: '',
};
